import React from "react";

const PdShimmer = () => {
  return (
    <div className="mt-10 bg-gray-200 border rounded-3xl p-8 text-center shadow-sm">
      {/* Avatar + edit button */}
      <div className="relative w-fit mx-auto">
        <div className="w-36 h-36 rounded-full shimmer ring-4 ring-gray-200 shadow-md mx-auto" />
        <div className="absolute bottom-2 right-2 w-9 h-9 rounded-full shimmer shadow-md" />
      </div>

      {/* Name */}
      <div className="mt-4 w-32 h-6 shimmer rounded mx-auto" />

      {/* Email */}
      <div className="mt-2 w-48 h-4 shimmer rounded mx-auto" />

      {/* Description */}
      <div className="mt-4 w-64 h-4 shimmer rounded mx-auto" />
      <div className="mt-2 w-56 h-4 shimmer rounded mx-auto" />
    </div>
  );
};

export default PdShimmer;
